const isInternalLink = url => {
  if (typeof url === "string" || url instanceof String) {
    return url.startsWith("/");
  }
  return false;
};

const wpMenuToNavigation = wpMenus => {
  function convert(menus) {
    return menus.map((menu, index) => {
      const converted = { id: index };

      if (menu.hassubnavigation || menu.hasSubnavigation) {
        converted.menu = menu?.subnavigation?.length > 0 ? convert(menu.subnavigation) : [];
        converted.title = menu?.title;
      } else {
        converted.url = menu?.link?.url;
        converted.title = menu?.link?.title;
        converted.isInternalLink = isInternalLink(menu?.link?.url);
        converted.target = menu?.link?.target;
      }
      return converted;
    });
  }

  return convert(wpMenus);
};

const normalizeMenuData = wpMenu => {
  const { navigation } = wpMenu;

  return wpMenuToNavigation(navigation || []);
};

const normalizeLogoData = logos => {
  const { country, main } = logos.logos;
  return {
    startLogo: main?.localFile?.childImageSharp?.fixed?.src,
    endLogo: country?.localFile?.childImageSharp?.fixed?.src
  };
};

const normalizeFooterData = (footer, translate) => {
  const { contact, faq, navigation } = footer;
  const footerMenu = {
    navigation: [
      {
        id: 0,
        isInternalLink: isInternalLink(faq?.link?.url),
        target: faq?.link?.target,
        title: faq?.link?.title,
        url: faq?.link?.url
      }
    ]
  };
  if (contact?.addRecipient) {
    footerMenu.contact = {
      recipient: contact?.recipient,
      title: translate("Contact System Administrator")
    };
  }

  if (navigation) {
    navigation.forEach((menu, index) => {
      footerMenu.navigation.push({
        id: index + 1,
        isInternalLink: isInternalLink(menu?.link?.url),
        target: menu?.link?.target,
        title: menu?.link?.title,
        url: menu?.link?.url
      });
    });
  }

  return footerMenu;
};

export { normalizeMenuData, normalizeLogoData, normalizeFooterData, isInternalLink };
